import { validationRulesFunction } from './validationRules';

export interface ValidateResponse {
    valid: boolean;
    reason: string;
    name: string;
    rejected: boolean;
}

export interface RuleParams {
    [ruleName: string]: any;
}

export class Validator {
    private rules: { [key: string]: (...params: any) => ValidateResponse | Promise<ValidateResponse> } = {};

    validate = async (params: RuleParams) => {
        const responses: ValidateResponse[] = [];
        for (const name in this.rules) {
            const func = this.rules[name];
            const funcParam = params[name];
            if (funcParam === undefined) continue;
            try {
                const response = await func({ ...funcParam });
                responses.push(response);
            } catch (error) {
                console.error('Validation error for ' + name, error);
                console.log(name + ' func:', func);
                console.log(name + ' funcParam:', funcParam);
            }
        }
        return responses;
    };

    addRule = (name: string) => {
        // TODO: We silently ignore rules that we don't have, this is not good, but it's good enough for now
        if (validationRulesFunction[name]) {
            this.rules[name] = validationRulesFunction[name];
        }
    };

    clearRules = () => {
        this.rules = {};
    };
}
